"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorModal = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _getENV = require("../../Utils/getENV");

var _ModalDialog = require("./ModalDialog");

var _ModalWrapper = require("./ModalWrapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @deprecated use `Dialogs` and `injectDialogs` instead
 */
var ErrorModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ErrorModal, _React$Component);

  function ErrorModal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ErrorModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ErrorModal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.props.onClose && _this.props.onClose();
    });

    return _this;
  }

  _createClass(ErrorModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          onClose = _this$props.onClose,
          headerText = _this$props.headerText,
          detailText = _this$props.detailText,
          errorStack = _this$props.errorStack,
          contactEmail = _this$props.contactEmail,
          closeText = _this$props.closeText,
          ctaAction = _this$props.ctaAction;
      var emailAddress = contactEmail ? contactEmail : "support@artsy.net";
      var showErrorStack = errorStack && (0, _getENV.getENV)("NODE_ENV") !== "production";
      var width = (0, _getENV.getENV)("NODE_ENV") === "development" ? _ModalWrapper.ModalWidth.Wide : _ModalWrapper.ModalWidth.Narrow;
      return _react.default.createElement(_ModalDialog.ModalDialog, {
        show: show,
        onClose: onClose,
        heading: headerText,
        width: width,
        detail: _react.default.createElement(_react.default.Fragment, null, detailText || _react.default.createElement(_react.default.Fragment, null, "Something went wrong. Please try again or contact", " ", _react.default.createElement(_palette.Link, {
          href: "mailto:".concat(emailAddress)
        }, emailAddress), "."), showErrorStack && _react.default.createElement(_palette.Box, {
          py: 3
        }, _react.default.createElement(_palette.Box, {
          style: {
            whiteSpace: "pre-wrap"
          }
        }, errorStack))),
        primaryCta: {
          action: ctaAction || onClose,
          text: closeText
        }
      });
    }
  }]);

  return ErrorModal;
}(_react.default.Component);

exports.ErrorModal = ErrorModal;

_defineProperty(ErrorModal, "defaultProps", {
  headerText: "An error occurred",
  closeText: "Continue"
});
//# sourceMappingURL=ErrorModal.js.map